import {Loading} from 'element-ui'
import {loadingText} from '@/setting.config'


export default {
  install(Vue) {
    Vue.prototype.$baseLoading = (index, text) => {
      let loading
      if (!index) {
        loading = Loading.service({
          lock: true, text: text || loadingText, background: 'hsla(0,0%,100%,.8)',
        })
      } else {
        loading = Loading.service({
          lock: true,
          text: text || loadingText,
          spinner: 'app-loading-type' + index,
          background: 'hsla(0,0%,100%,.8)',
        })
      }
      return loading
    }
    Vue.prototype.$formatPrice = (price) => {
      return String(price ?? '').replace(/\B(?=(\d{3})+(?!\d))/g, ',') ?? ''
    }
  }
}
